import { Body } from '@shipt/design-system-typography'
import { useIsProductSnapEbtEligible } from '@/features/shared/hooks/useIsProductSnapEbtEligible'

type Props = {
  isSnapEbtEligible: boolean
}

export const EBTEligible = ({ isSnapEbtEligible }: Props) => {
  const isEbtEligible = useIsProductSnapEbtEligible(isSnapEbtEligible)
  if (!isEbtEligible) return null
  return (
    <Body size="md" variant="secondary">
      EBT eligible
    </Body>
  )
}
